import { axiosInstance } from "@/utilities";
import { API_URL_PERMISSIONS } from "@/services/XCONS_ENV";

// In-memory cache of technical operator contactIds (set per store via Magento
// `core_config_data` at path `api/general/customer_email`). Fetched once on
// first access and reused for the whole session. authProvider clears the cache
// on login/logout so the next page mount refetches.

type OperatorContactRow = { storeCode: string; contactId: number };

let cached: Set<number> | null = null;
let pending: Promise<Set<number>> | null = null;

export const clearOperatorContactsCache = (): void => {
  cached = null;
  pending = null;
};

export const getOperatorContactIds = async (): Promise<Set<number>> => {
  if (cached) return cached;
  if (pending) return pending;

  pending = axiosInstance
    .get<OperatorContactRow[]>(`${API_URL_PERMISSIONS}/operator-contacts`)
    .then((res) => {
      const next = new Set<number>(
        (res.data || []).map((r) => Number(r.contactId)).filter(Boolean),
      );
      cached = next;
      return next;
    })
    .catch(() => {
      // On failure, cache an empty set so we don't hammer the endpoint, but
      // do not surface the error — falling back to "show all participants"
      // is the safer UX.
      const empty = new Set<number>();
      cached = empty;
      return empty;
    })
    .finally(() => {
      pending = null;
    });

  return pending;
};
